<button class="btn" [style.background-color]="themeColor" OnHoverDarken [color]="themeColor">
    <strong>{{buttonText}}</strong>
</button>
